
export const fonts = {
    fonts: {
        body: '"Encode Sans", sans-serif'
    },
    fontSizes: [12, 14, 16, 18, 20, 22, 24, 32, 36]
}